<ng-container *ngIf="!isLoading; else skeleton">
  <label
          class="delivery-point-item"
          *ngFor="
    let deliveryPoint of deliveryPoints;
    let i = index;
    trackBy: trackByCode
  "
  >
    <custom-radio-button
            class="delivery-point-radio-button"
            [name]="radioButtonName"
            [value]="deliveryPoint"
            [formControl]="selectedDeliveryPointControl"
            [checked]="
      selectedDeliveryPointControl.value &&
      selectedDeliveryPointControl.value.code === deliveryPoint.code
    "
            [blocked]="deliveryPoint.blocked"
    ></custom-radio-button>
    <app-delivery-point-item
            [deliveryPoint]="deliveryPoint"
            [blocked]="deliveryPoint.blocked"
    ></app-delivery-point-item>
    <button
            *ngIf="
      hasDeleteButton &&
      selectedDeliveryPointControl.value &&
      selectedDeliveryPointControl.value.code !== deliveryPoint.code
    "
            class="delete-button"
            (click)="onClickDeleteButton.emit(deliveryPoint)"
    >
      <svg-icon class="app-bar__icon" src="./assets/icons/trash.svg"></svg-icon>
    </button>
  </label>
</ng-container>

<ng-template #skeleton>
  <ngx-skeleton-loader
          *ngFor="let i of [0,0,0,0]"
          class="skeleton-loader image"
          [theme]="{
            'height': '92px',
            'width': '100%',
            'background-color': 'var(--skeleton-background-color)',
            'foregroundColor': 'red',
            'margin-bottom': '16px'
        }"
  ></ngx-skeleton-loader>
</ng-template>
